import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarDriversApi } from "../../http/carDrivers/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarDriverDialogProps = {
  carDriverId: string;
  carId: string;
  onClose: (success?: boolean) => void;
};

const DeleteCarDriverDialog: FC<DeleteCarDriverDialogProps> = ({ carDriverId, carId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const carDriversApi = useCarDriversApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.carDrivers.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carDriversApi
              .deleteAdminCarDriver(carDriverId, carId)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => {
                onClose(true);
                dispatch(showSuccessNotification(i18n.t));
              })
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.carDrivers.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarDriverDialog;
